"use client"

import { motion } from "framer-motion"
import { Instagram, Linkedin } from "lucide-react"

const socials = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/sigmai_sports/",
    icon: Instagram,
    description: "Player moments, matchdays and behind the scenes.",
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/sigmai-sports/",
    icon: Linkedin,
    description: "Company news and platform updates.",
  },
]

export function SocialLinks() {
  return (
    <section id="socials" className="scroll-mt-24 bg-white py-16 md:py-20">
      <div className="container mx-auto max-w-3xl px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span className="text-sm font-semibold uppercase tracking-wider text-blue-600">
            Stay up to date
          </span>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 md:text-4xl">
            Follow our socials
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-slate-600">
            Keep up with SigmAI for the latest player updates, news and platform
            developments.
          </p>
        </motion.div>

        <div className="mt-10 flex flex-col items-stretch justify-center gap-4 sm:flex-row">
          {socials.map((social, index) => (
            <motion.a
              key={social.label}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.08 }}
              className="group flex flex-1 items-center gap-4 rounded-2xl border border-slate-200 bg-slate-50 px-5 py-4 text-left transition-all duration-300 hover:border-blue-200 hover:bg-white hover:shadow-md"
            >
              <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gradient-to-r from-blue-600 to-cyan-500 text-white">
                <social.icon className="h-5 w-5" strokeWidth={1.75} />
              </span>
              <span>
                <span className="block text-base font-semibold text-slate-900">
                  {social.label}
                </span>
                <span className="mt-0.5 block text-sm text-slate-500">
                  {social.description}
                </span>
              </span>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  )
}
